import { useSingleLocationSuspense } from "@/modules/location/locationQuery.ts";

export function LocationItem({ value }: { value: string }) {
    const location = useSingleLocationSuspense(value);
    return (
        <>
            <span className="text-nowrap">{location?.display_name}</span> ({value})
        </>
    );
}
